// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__11CD8","validationTips":"StatementDescriptor_validationTips__1yGEz"};